import { createContext } from 'react'

export type Theme = 'light' | 'dark' | 'system'

export const THEME_STORAGE_KEY = 'theme'

export type ThemeValue = {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const ThemeContext = createContext<ThemeValue>({ theme: 'system', setTheme: () => {} })

/**
 * Тема для содержимого порталов — `Popover`, `Tooltip`, `Modal` монтируются в `body` и темы
 * своего экрана не видят. Экран, который живёт в своей теме (вход всегда тёмный), кладёт её сюда,
 * и порталы ставят `data-theme` на свой корень. `null` — тема приложения.
 */
export const PortalThemeContext = createContext<'light' | 'dark' | null>(null)
